/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  regStartDate: '',
  lrInstallerSubmitClaimStartDate: '',
  lrClaimStartDate: '',
  pmcStartDate: '',
  pmcRegStartDate: '',
  pmcClientRegStartDate: '',
};

export const gaSlice = createSlice({
  name: 'gaSlice',
  initialState,
  reducers: {
    setRegStartDate: (state, action) => {
      state.regStartDate = action.payload;
    },
    setLrInstallerSubmitClaimStartDate: (state, action) => {
      state.lrInstallerSubmitClaimStartDate = action.payload;
    },
    setLrClaimStartDate: (state, action) => {
      state.lrClaimStartDate = action.payload;
    },
    setPmcStartDate: (state, action) => {
      state.pmcStartDate = action.payload;
    },
    setPmcRegStartDate: (state, action) => {
      state.pmcRegStartDate = action.payload;
    },
    setPmcClientRegStartDate: (state, action) => {
      state.pmcClientRegStartDate = action.payload;
    },
  },
});

export const {
  setRegStartDate,
  setLrInstallerSubmitClaimStartDate,
  setLrClaimStartDate,
  setPmcStartDate,
  setPmcRegStartDate,
  setPmcClientRegStartDate,
} = gaSlice.actions;

export const getRegStartDate = (state) => state.gaSlice.regStartDate;

export const getLrInstallerSubmitClaimStartDate = (state) =>
  state.gaSlice.lrInstallerSubmitClaimStartDate;

export const getLrClaimStartDate = (state) => state.gaSlice.lrClaimStartDate;
export const getPmcStartDate = (state) => state.gaSlice.pmcStartDate;
export const getPmcRegStartDate = (state) => state.gaSlice.pmcRegStartDate;
export const getPmcClientRegStartDate = (state) =>
  state.gaSlice.pmcClientRegStartDate;

export default gaSlice.reducer;
